// Vendors
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
// Contexts
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
import { useUploadIdContextConsumerHook } from 'containers/upload-id/contexts/upload-id.context';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
// Event Handlers
import { UploadIdErrorHandlers } from '../handlers/upload-id-error.handlers';
import { UploadIdErrorTrackingHandlers } from '../handlers/upload-id-error.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';

const useUploadIdErrorHook = (): void => {
  const { formatMessage } = useIntl();

  const { setUploadIdState } = useUploadIdContextConsumerHook(),
    { setMainButtonConfiguration } = useLayoutContextConsumerHook(),
    { setError } = useFetchErrorContextConsumerHook(),
    { handleTrackTryAgain } = useAppTrackingHook(UploadIdErrorTrackingHandlers);

  const { handleSetupUploadIdErrorButtonConfiguration } = UploadIdErrorHandlers({
    handleTrackTryAgain,
    formatMessage,
    setError,
    setMainButtonConfiguration,
    setUploadIdState,
  });

  useEffect(() => {
    handleSetupUploadIdErrorButtonConfiguration();
  }, []);
};

export { useUploadIdErrorHook };
